import React from 'react';
import { FadeIn, Section, Button } from './ui';
import { Check, Shield, Download, BookOpen, ClipboardCheck, CalendarDays } from 'lucide-react';
export function HeroSection() {
  return <div className="relative pt-10" data-id="element-155">
      {/* Urgency Bar */}
      <div className="fixed top-0 left-0 right-0 bg-brand-green text-white text-center py-2.5 px-4 z-50 font-bold text-xs md:text-base shadow-md" data-id="element-156">
        ⚡DOCENTE DE MATEMÁTICA DEJÁ DE PERDER TIEMPO
      </div>

      <Section variant="dark" className="!pt-2 md:!pt-16 !pb-6 md:!pb-10" data-id="element-157">
        <FadeIn data-id="element-158">
          <h1 className="text-[22px] md:text-5xl font-black text-gray-900 leading-[1.15] text-center mb-3 md:mb-5" data-id="element-159">
            MegaPack Matemática 360 — 12 tomos completos{' '}
            <span className="text-brand-green" data-id="element-160">
              para docentes de primaria y secundaria
            </span>
          </h1>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-161">
          {/* Product Image */}
          <div className="relative w-full max-w-[260px] md:max-w-[520px] mx-auto mb-4 md:mb-8" data-id="element-162">
            <img src="https://cdn.magicpatterns.com/uploads/rPq6DmiVVLWuG6j8WUtXHi/35.png" alt="MegaPack Matemática 360 — Primaria y Secundaria. Incluye 12 tomos, planificación anual, ebooks elite y bonos." className="w-full h-auto drop-shadow-[0_20px_40px_rgba(37,99,235,0.18)]" loading="eager" decoding="async" data-id="element-163" />
          </div>
        </FadeIn>

        <FadeIn delay={0.15} data-id="element-164">
          <p className="text-sm md:text-xl text-gray-600 text-center mb-4 md:mb-8 max-w-[600px] mx-auto leading-relaxed" data-id="element-165">
            Este sistema te da las clases y las pruebas listas para usar. Deja
            de empezar desde cero cada semana.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-166">
          {/* Feature Badges */}
          <div className="flex flex-wrap justify-center gap-3 md:gap-4 mb-4 md:mb-8" data-id="element-167">
            <div className="flex items-center gap-2 bg-brand-green/10 border border-brand-green/20 rounded-full px-4 py-2 md:px-5 md:py-2.5" data-id="element-168">
              <BookOpen size={18} className="text-brand-green shrink-0" data-id="element-169" />
              <span className="text-brand-green font-semibold text-sm md:text-base" data-id="element-170">
                Clases
              </span>
            </div>
            <div className="flex items-center gap-2 bg-brand-green/10 border border-brand-green/20 rounded-full px-4 py-2 md:px-5 md:py-2.5" data-id="element-171">
              <ClipboardCheck size={18} className="text-brand-green shrink-0" data-id="element-172" />
              <span className="text-brand-green font-semibold text-sm md:text-base" data-id="element-173">
                Pruebas
              </span>
            </div>
            <div className="flex items-center gap-2 bg-brand-green/10 border border-brand-green/20 rounded-full px-4 py-2 md:px-5 md:py-2.5" data-id="element-174">
              <CalendarDays size={18} className="text-brand-green shrink-0" data-id="element-175" />
              <span className="text-brand-green font-semibold text-sm md:text-base" data-id="element-176">
                Planificaciones
              </span>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.25} data-id="element-177">
          <Button href="#pricing" variant="primary" className="text-base md:text-xl mb-3 md:mb-5" data-id="element-178">
            <span data-id="element-179">Sí, QUIERO EL SISTEMA AHORA →</span>
          </Button>

          <div className="flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs md:text-sm text-gray-500" data-id="element-180">
            <div className="flex items-center gap-1" data-id="element-181">
              <Check size={14} className="text-brand-green shrink-0" data-id="element-182" />
              <span data-id="element-183">+847 docentes</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-184">
              <Download size={14} className="text-brand-blue shrink-0" data-id="element-185" />
              <span data-id="element-186">PDF al instante</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-187">
              <Shield size={14} className="text-brand-gold shrink-0" data-id="element-188" />
              <span data-id="element-189">Garantía 7 días</span>
            </div>
          </div>
        </FadeIn>
      </Section>
    </div>;
}